import { render, staticRenderFns } from "./LinkDoPasso.vue?vue&type=template&id=39b7779c&scoped=true"
import script from "./LinkDoPasso.vue?vue&type=script&lang=js"
export * from "./LinkDoPasso.vue?vue&type=script&lang=js"
import style0 from "./LinkDoPasso.vue?vue&type=style&index=0&id=39b7779c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7779c",
  null
  
)

export default component.exports